<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>Sister’s Choice</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9781460302989.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="acknowledgePage" id="ack"><h2 class="acknowledgeHead" style="text-indent: 0%">ACKNOWLEDGMENT</h2><p class="acknowledgeText" style="text-indent: 0%">When novels become alive for readers, new and interesting ideas can develop. One such idea was suggested to me by Pam Brown of Muscatine, Iowa, at a quilt-show book signing. So thanks to Pam, who wasn’t shy about talking to me, for sending my own imagination in a brand-new and fruitful direction. Thanks, too, to the Brainstormers, Jasmine, Karen, Connie and Diane, for their energy and creativity.</p><p class="acknowledgeText" style="text-indent: 0%">Two sisters answered the call for a Sister’s Choice quilt for this cover, one the quilt maker, one the recipient. Thanks to Kathy Rankin and Jeanne Prue for sharing their quilt. How appropriate that Jeanne’s quilt, made to celebrate Kathy’s brand-new master’s degree, would inspire the cover art on a novel about the love between sisters.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460302989_ack.vue?4fef3504